import React, { useState } from 'react';
import { Mail, MapPin, Send } from 'lucide-react';
import { companyInfo } from '../mockData';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      toast.success('Message sent successfully! We will be in touch soon.');
      setFormData({ name: '', email: '', company: '', message: '' });
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section style={{
        padding: '100px 7.6923% 60px',
        background: 'var(--bg-primary)',
        textAlign: 'center'
      }}>
        <div style={{
          width: '80px',
          height: '2px',
          background: 'var(--brand-primary)',
          margin: '0 auto 30px'
        }} />
        <h1 className="display-large">Contact Us</h1>
        <p className="body-large" style={{
          maxWidth: '700px',
          margin: '20px auto 0',
          color: 'var(--text-secondary)'
        }}>
          Get in touch with our team to discuss how we can support your international trade ambitions.
        </p>
      </section>

      {/* Contact Content */}
      <section style={{
        padding: '60px 7.6923% 100px',
        background: 'var(--bg-primary)'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '80px'
        }}>
          {/* Contact Form */}
          <div>
            <h2 className="display-medium" style={{
              marginBottom: '30px'
            }}>
              Send us a Message
            </h2>
            
            <form onSubmit={handleSubmit} style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px'
            }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '8px',
                  color: 'var(--text-primary)'
                }}>
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    borderRadius: '0',
                    color: 'var(--text-primary)',
                    fontSize: '16px',
                    fontFamily: 'Inter, sans-serif',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--brand-primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border-subtle)'}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '8px',
                  color: 'var(--text-primary)'
                }}>
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    borderRadius: '0',
                    color: 'var(--text-primary)',
                    fontSize: '16px',
                    fontFamily: 'Inter, sans-serif',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--brand-primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border-subtle)'}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '8px',
                  color: 'var(--text-primary)'
                }}>
                  Company Name
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    borderRadius: '0',
                    color: 'var(--text-primary)',
                    fontSize: '16px',
                    fontFamily: 'Inter, sans-serif',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--brand-primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border-subtle)'}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  marginBottom: '8px',
                  color: 'var(--text-primary)'
                }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    borderRadius: '0',
                    color: 'var(--text-primary)',
                    fontSize: '16px',
                    fontFamily: 'Inter, sans-serif',
                    resize: 'vertical',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--brand-primary)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border-subtle)'}
                />
              </div>

              <button 
                type="submit" 
                className="btn-primary"
                disabled={isSubmitting}
                style={{
                  opacity: isSubmitting ? 0.7 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
                <Send size={20} />
              </button>
            </form>
          </div>

          {/* Contact Information & Map */}
          <div>
            <h2 className="display-medium" style={{
              marginBottom: '30px'
            }}>
              Get in Touch
            </h2>

            {/* Contact Details */}
            <div style={{
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border-subtle)',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <div style={{
                marginBottom: '30px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '12px'
                }}>
                  <Mail size={24} color="var(--brand-primary)" />
                  <h3 className="heading-2">Email</h3>
                </div>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  style={{
                    fontSize: '18px',
                    color: 'var(--brand-primary)',
                    textDecoration: 'none',
                    transition: 'opacity 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.opacity = '0.8'}
                  onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                  {companyInfo.email}
                </a>
              </div>

              <div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  marginBottom: '12px'
                }}>
                  <MapPin size={24} color="var(--brand-primary)" />
                  <h3 className="heading-2">Address</h3>
                </div>
                <p style={{
                  fontSize: '18px',
                  color: 'var(--text-secondary)',
                  lineHeight: '1.6',
                  margin: 0
                }}>
                  {companyInfo.address}
                </p>
              </div>
            </div>

            {/* Google Map */}
            <div style={{
              width: '100%',
              height: '400px',
              border: '1px solid var(--border-subtle)',
              overflow: 'hidden'
            }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2728.8!2d7.0897!3d46.7897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDbCsDQ3JzIzLjAiTiA3wrAwNScyMy4wIkU!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Promesa Trading Location"
              />
            </div>

            {/* Confidential Call CTA */}
            <div style={{
              marginTop: '30px',
              padding: '30px',
              background: 'rgba(212, 175, 55, 0.1)',
              border: '1px solid var(--brand-primary)'
            }}>
              <h3 className="heading-2" style={{
                marginBottom: '12px',
                color: 'var(--brand-primary)'
              }}>
                Prefer a Confidential Discussion?
              </h3>
              <p style={{
                fontSize: '16px',
                color: 'var(--text-secondary)',
                lineHeight: '1.6',
                margin: 0
              }}>
                We value genuine, face-to-face interactions. Contact us via email to schedule a personal meeting and discuss your international trade needs in confidence.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Responsive Grid */}
        <style>{`
          @media (max-width: 1024px) {
            section > div {
              grid-template-columns: 1fr !important;
              gap: 60px !important;
            }
          }
        `}</style>
      </section>
    </div>
  );
};

export default Contact;